const FILE_PATH_LIKE = /^[^\s]+\/[^\s]+\.[A-Za-z0-9]{2,5}(?:\?.*)?$/;
const GLUED_PATHS_SPLIT = /(?<=\.[A-Za-z0-9]{2,5})(?=[A-Za-z0-9_-]+\/)|[,\n;]+/;

export function attachmentValues(value) {
  const flat = Array.isArray(value) ? value : [value];
  return flat
    .filter((item) => item != null && item !== '' && item !== '-')
    .flatMap((item) => (
      typeof item === 'string'
        ? item.split(GLUED_PATHS_SPLIT).map((part) => part.trim()).filter(Boolean)
        : [item]
    ));
}

function looksLikeAttachmentValue(value) {
  const items = attachmentValues(value);
  return items.length > 0 && items.every((item) => typeof item === 'string' && FILE_PATH_LIKE.test(item));
}

export function resolveIsAttachmentField(field, value) {
  const fieldType = String(field?.fieldType || '').toLowerCase();
  return fieldType === 'file'
    || fieldType === 'images'
    || fieldType === 'image'
    || looksLikeAttachmentValue(value);
}

export function collectAttachmentPaths(fields, rows) {
  const paths = new Set();
  rows.forEach((row) => {
    fields.forEach((field) => {
      const value = row[field.key] ?? '-';
      if (!resolveIsAttachmentField(field, value)) return;
      attachmentValues(value).forEach((item) => {
        if (typeof item === 'string') paths.add(item);
      });
    });
  });
  return Array.from(paths);
}
